module.exports = {
      id: "tomato-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#tomato",
      toString: function () {
        return this.url;
      }
    }